import React, { useState } from 'react'
import styled from 'styled-components'
import SessionDialog from '../../sessions/components/SessionDialog'

const Field = styled.div`
  margin-bottom: 12px;
`
const Label = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${(p) => p.theme?.color?.inkMuted || '#6B7280'};
  margin-bottom: 4px;
`
const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme?.color?.border || '#E6E0D6'};
  font-family: inherit;
  font-size: 14px;
`
const TextArea = styled.textarea`
  width: 100%;
  min-height: 70px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme?.color?.border || '#E6E0D6'};
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
`

export default function MealLogDialog({ open, mealType, mealLabel, onClose, onSubmit }) {
  const [items, setItems] = useState('')
  const [quantity, setQuantity] = useState('')
  const [note, setNote] = useState('')
  const [busy, setBusy] = useState(false)

  async function handle() {
    setBusy(true)
    try {
      await onSubmit({
        mealType,
        items: items
          .split(/[,\n]+/)
          .map((s) => s.trim())
          .filter(Boolean),
        quantity: quantity.trim() || null,
        note: note.trim() || null,
      })
      setItems('')
      setQuantity('')
      setNote('')
      onClose()
    } finally {
      setBusy(false)
    }
  }

  return (
    <SessionDialog
      open={open}
      title={`Log ${mealLabel || 'meal'}`}
      primaryLabel="Save"
      primaryDisabled={!items.trim()}
      primaryLoading={busy}
      onPrimary={handle}
      onClose={onClose}
    >
      <Field>
        <Label>What did you eat?</Label>
        <Input
          value={items}
          onChange={(e) => setItems(e.target.value)}
          placeholder="e.g. oats, banana, coffee"
        />
      </Field>
      <Field>
        <Label>Quantity (optional)</Label>
        <Input
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
          placeholder="e.g. 1 bowl, 2 cups"
        />
      </Field>
      <Field>
        <Label>Note (optional)</Label>
        <TextArea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Anything else"
        />
      </Field>
    </SessionDialog>
  )
}
